import React, { isValidElement, cloneElement } from 'react';
import ShoppingCartSummaryStyled from './bundle.esm2.js';
import { getChildren } from '../../utils/bundle.esm2.js';
import ShoppingCartSummaryDiscount from './ShoppingCartSummaryDiscount/bundle.esm.js';
import ShoppingCartSummaryPoints from './ShoppingCartSummaryPoints/bundle.esm.js';
import ShoppingCartSummaryShippingCost from './ShoppingCartSummaryShippingCost/bundle.esm.js';
import ShoppingCartSummarySubtotal from './ShoppingCartSummarySubtotal/bundle.esm.js';
import ShoppingCartSummaryTaxes from './ShoppingCartSummaryTaxes/bundle.esm.js';
import ShoppingCartSummaryTotal from './ShoppingCartSummaryTotal/bundle.esm.js';
import { defaultFormatter } from './bundle.esm3.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const ShoppingCartSummary = (props) => {
  const { className, title = "Resumen del carrito" } = props;
  const { shoppingCartTotals, formatter, children } = props;
  const renderChildren = () => {
    return getChildren(children).map((child, index) => {
      if (!child) {
        return null;
      }
      if (!isValidElement(child)) {
        return child;
      }
      const parentFormatter = formatter ? formatter : {};
      const childFormatter = child.props.formatter ? child.props.formatter : {};
      return cloneElement(child, {
        key: index,
        shoppingCartTotals,
        formatter: __spreadValues(__spreadValues({}, parentFormatter), childFormatter)
      });
    });
  };
  return /* @__PURE__ */ React.createElement(ShoppingCartSummaryStyled, {
    className: `ShoppingCartSummary ${className}`
  }, /* @__PURE__ */ React.createElement("div", {
    className: "ShoppingCartSummary__title"
  }, title), /* @__PURE__ */ React.createElement("div", {
    className: "ShoppingCartSummary__summary"
  }, renderChildren()));
};
ShoppingCartSummary.defaultProps = {
  className: "",
  title: "Resumen del carrito",
  formatter: defaultFormatter
};
ShoppingCartSummary.Subtotal = ShoppingCartSummarySubtotal;
ShoppingCartSummary.ShippingCost = ShoppingCartSummaryShippingCost;
ShoppingCartSummary.Points = ShoppingCartSummaryPoints;
ShoppingCartSummary.Taxes = ShoppingCartSummaryTaxes;
ShoppingCartSummary.Discount = ShoppingCartSummaryDiscount;
ShoppingCartSummary.Total = ShoppingCartSummaryTotal;

export { ShoppingCartSummary as default };
//# sourceMappingURL=bundle.esm.js.map
